// const bannerClasses = classNames({

//     // [css.setBannerRowBackground]: true,
//     // [css.film]: false,
//     // [css.halloween]: false,
//     // [css.hp]: false,
//     // [css.maxim]: false,
//     // [css.ny]: false,
//     // [css.romantic]: false,
//     // [css.maslenitsa]: false,
//     // [css.marchgifts]: false,
//     // [css.march]: false,
//     [css[]]: true,
// });

// // const FilmSetLink = '/film/';
// // const HalloweenSetLink = '/halloween/';
// // const hpSetLink = '/hp/';
// // const maximSetLink = '/maximonline/?erid=2SDnjer5shV';
// // const nyLPLink = '/blyuda-dlya-novogodnego-stola/';
// // const romanticLink = '/romantic/';
// // const maslenitsaLink = '/maslenitsa/';
// // const marchgiftsLink = '/marchgifts/';
// const womenLink = '/march/';


export function useBurgerMenuBanner() {
    return { name: 'hp', href: '/hp/' };
    // return { name: 'halloween', href: '/halloween/?save=dishes&erid=2SDnjchK4sW' };
    // return { name: 'school', href: '/backtoschool/' };
    // return { name: 'gryadka', href: '/menu?st=gryadka' };
    // return { name: 'odyssey', href: '/menu?period=2026-07-13&st=odyssey' };
    // return { name: 'dacha', href: '/dacha/' };
    // return { name: 'sabantuy', href: '/sabantuy/' };
    // return { name: 'biomio', href: '/biomio/' };
    // return { name: 'easter', href: '/easterbox/' };
    // return { name: 'march', href: '/march/' };
    // return { name: 'marchgifts', href: '/marchgifts/' };
    // return { name: 'maslenitsa', href: '/maslenitsa/' };
    // return { name: 'romantic', href: '/romantic/' };
    // return { name: 'ny', href: '/christmas/' };
    // return { name: 'wednesday', href: '/menu/dish/5050/' };
    // return { name: 'squidgame', href: '/squid-game/' };
    // return { name: 'YaP', href: '/practicum.yandex/?erid=2SDnjcg1GtC' };
    // return null;
}
